import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../config";

interface MetricPanelProps {
  title: string;
  children: React.ReactNode;
  variant?: "success" | "fail" | "info" | "default" | "warning";
}

const BG_COLORS = {
  success: colors.success.background,
  info: colors.info.background,
  fail: colors.error.background,
  default: colors.default.background,
  warning: colors.warning.background,
};

const FONT_COLORS = {
  success: colors.success.text,
  info: colors.info.text,
  fail: colors.error.text,
  default: colors.default.text,
  warning: colors.warning.text,
};

export default function MetricPanel({
  title,
  variant = "default",
  children,
}: MetricPanelProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        borderRadius: "4px",
        border: `1px solid ${colors.border.dark}`,
        width: "100%",
        margin: 0,
      }}
    >
      <Box
        sx={{
          bgcolor: colors.background.mediumGray,
          borderBottom: `1px solid ${colors.border.dark}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "4px 4px 0px 0px",
          minHeight: "22px",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: colors.text.tertiary,
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          bgcolor: BG_COLORS[variant],
          color: FONT_COLORS[variant],
          borderRadius: "0px 0px 4px 4px",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          minHeight: "30px",
          alignItems: "center",
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "18px",
          padding: "4px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

